module.exports = __webpack_public_path__ + "img/imoto_logo.8f6c0c19.png";